export default {
  allBids: (state) => state.bids
}
